import React, { useContext } from "react";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import { GlobalContext } from "../../context/GlobalContext";
import { MUTATION_LOGOUT } from "../../Graphql/mutations/MutationLogout";
import { RoutesNames } from "../../components/utils/routes";
import { useToastError } from "../../Hooks/useToastError";
import { useToastLoading } from "../../Hooks/useToastLoading";
import { useToastSuccessful } from "../../Hooks/useToastSuccessful";

import { Modal, Content, OptionClick, TextQuestion } from "./styles";

const ModalLogOut = ({ modalVisible, setModalVisible }) => {
  const { token, setToken, setRol, setUser } = useContext(GlobalContext);
  const navigate = useNavigate();
  const toastSuccessful = useToastSuccessful();

  const [logoutMutation, { loading, error }] = useMutation(MUTATION_LOGOUT, {
    onCompleted: () => {
      navigate(RoutesNames.login);
      toastSuccessful("sesión cerrada correctamente");
      setToken(null);
      setRol(null);
      setUser(null);
    },
    onError: (err) => console.error(err),
  });

  // Toasts
  useToastError(error);
  useToastLoading(loading);

  const handleLogOut = async () => {
    setModalVisible(true);
    window.sessionStorage.removeItem("secret_key");
    window.localStorage.removeItem("rol_user");
    window.localStorage.removeItem("name_user");

    logoutMutation({
      variables: {
        token: token,
      },
    });
  };

  return (
    modalVisible && (
      <Modal onClick={() => setModalVisible(false)}>
        <Content onClick={(event) => event.stopPropagation()}>
          <TextQuestion>¿Desea cerrar sesión?</TextQuestion>
          <OptionClick onClick={handleLogOut}>Si, deseo hacerlo</OptionClick>
          <OptionClick onClick={() => setModalVisible(false)}>No, deseo continuar</OptionClick>
        </Content>
      </Modal>
    )
  );
};

ModalLogOut.propTypes = {
  modalVisible: PropTypes.bool,
  setModalVisible: PropTypes.func,
};

export default ModalLogOut;
